export enum Actives {
  ALL = 'all',
  TRUE = 'true',
  FALSE = 'false'
}
